<template>
  <div
    class="rounded-md overflow-hidden shadow-lg border border-gray-200 bg-white"
  >
    <div
      class="flex flex-row gap-4 mx-4 my-2.5"
    >
      <font-awesome-icon
        :icon="props.icon"
        class="h2 text-[1.4em] p-1.5 aspect-square rounded bg-primary bg-server bg-department text-department-contrast text-white"
      />
      <h2
        class="my-auto text-slate-900"
      >
        {{ props.label }}
      </h2>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { Icon } from '~/utils/types'

const props = defineProps<{
  icon: Icon
  label: string
}>()
</script>
